import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SecuenciaPage } from './pages/SecuenciaPage';
import { DiagnosticoPage } from './pages/diagnostico/DiagnosticoPage';
import { TecnologiaPage } from './pages/tecnologia/TecnologiaPage';
import { EstructuraPage } from './pages/estructura/EstructuraPage';
import { PropositoPage } from './pages/proposito/PropositoPage';
render(<BrowserRouter data-id="element-142">
    <Routes data-id="element-143">
      <Route path="/" element={<App data-id="element-145" />} data-id="element-144" />
      <Route path="/secuencia" element={<SecuenciaPage data-id="element-147" />} data-id="element-146" />
      <Route path="/diagnostico" element={<DiagnosticoPage data-id="element-149" />} data-id="element-148" />
      <Route path="/tecnologia" element={<TecnologiaPage data-id="element-151" />} data-id="element-150" />
      <Route path="/estructura" element={<EstructuraPage data-id="element-153" />} data-id="element-152" />
      <Route path="/proposito" element={<PropositoPage data-id="element-155" />} data-id="element-154" />
    </Routes>
  </BrowserRouter>, document.getElementById('root'));